import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchFieldPlaceholder: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.search-field-placeholder',
		defaultMessage: 'Search fields',
		description: 'Placeholder of Search field',
	},
	thirdPartyFields: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.third-party-fields',
		defaultMessage: '{thirdParty} field',
		description: 'Header of third party column in field mapping table',
	},
	jwmFieldsSpork: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jwm-fields-spork',
		defaultMessage: 'Jira field',
		description: 'Header of Jira column in field mapping table',
	},
	jiraBusinessProjectFieldsSpork: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jira-business-project-fields-spork',
		defaultMessage: 'Business project field',
		description: 'Header of Business project column in field mapping table',
	},
	jiraSoftwareProjectFieldsSpork: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jira-software-project-fields-spork',
		defaultMessage: 'Software project field',
		description: 'Header of Software project column in field mapping table',
	},
	jiraCurrentProjectFields: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jira-current-project-fields',
		defaultMessage: 'Current project',
		description:
			'Header of the column showing the fields from the existing project which is to be imported in the field mapping table for internal Jira imports',
	},
	jiraNewProjectFields: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jira-new-project-fields',
		defaultMessage: 'New project',
		description:
			'Header of the column showing the fields the will be created in the new project which is to be imported in the field mapping table for internal Jira imports',
	},
	importToJira: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.import-to-jira',
		defaultMessage: 'Include in import',
		description: 'Header of import to Jira column in field mapping table',
	},
	exampleLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.example-label',
		defaultMessage: '{fieldName} (e.g. {exampleValue})',
		description: 'Header of import to Jira column in field mapping table',
	},
	noFields: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.no-fields',
		defaultMessage: 'There are no fields in your selected board.',
		description: 'Message shown when there are no fields to map',
	},
	itemTypes: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.item-types',
		defaultMessage: '{itemType} field mapping',
		description: 'The Tab to switch the item type',
	},
	itemTypeTab: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.item-type-tab',
		defaultMessage: 'Item field mapping',
		description: 'text of Monday Item',
	},
	subitemTab: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.subitem-tab',
		defaultMessage: 'Subitem field mapping',
		description: 'text of Monday Subitem',
	},
	itemType: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.item-type',
		defaultMessage: 'Item',
		description: 'text of Monday Item',
	},
	subitem: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.subitem',
		defaultMessage: 'Subitem',
		description: 'text of Monday Subitem',
	},
});
